import Layout from "../../../layout/Layout";
import React, { useRef, useEffect, useState } from "react";
import { Container } from "@mui/system";
import {
  Button,
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Autocomplete,
  FormGroup,
  FormControl,
  FormControlLabel,
  InputLabel,
  Switch,
  Select,
  MenuItem,
  Box,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Alert,
} from "@mui/material";

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
  timelineOppositeContentClasses,
} from "@mui/lab";
import DownloadIcon from "@mui/icons-material/Download";
import UserAvatar from "../../../components/UserAvatar";
import {
  ExpandMore as ExpandMoreIcon,
  Reply as ReplyIcon,
  Description as DescriptionIcon,
  Send as SendIcon,
} from "@mui/icons-material";
import {
  agentDashboardAPI,
  assetsAPI,
  config,
  ticketAPI,
  userDashboardAPI,
  userData,
  baseURL1,
  statusAPI,
} from "../../../config";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import moment from "moment/moment";
import { decryptVendorParams } from "../../../utils/vendorCrypto";
import { AlertMessage } from "../../../components/AlertMessage";
// import { Editor } from "@tinymce/tinymce-react";
import { TextEditor, getInnerHtml, addContentTo } from "text-editor-react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

let intIssueSubType = 0;
// let intAgentID = 0;

export default function AgentUpdateTicket() {
  const { ticketID } = useParams();
  const [expanded, setExpanded] = React.useState("panel1");
  const [vendorNameError, setVendorNameError] = React.useState("");
  const [intAgentID, setAgentID] = React.useState("");
  const [txtDescription, setDescription] = React.useState("");
  // const [flagReply, setFlagReply] = React.useState(false);
  const [contactDetails, setContactDetails] = React.useState({});
  const [timelineList, setTimelineList] = React.useState([]);
  const [agentList, setAgentList] = React.useState([]);

  const [intSubCategory, setSubCategory] = React.useState(0);
  const [intVendorID, setVendorID] = React.useState(0);

  // Action loading states
  const [isReplying, setIsReplying] = useState(false);
  const [isAssigningAgent, setIsAssigningAgent] = useState(false);
  const [isChangingCategory, setIsChangingCategory] = useState(false);
  const [isAssigningVendor, setIsAssigningVendor] = useState(false);
  const [isMarkingRepeated, setIsMarkingRepeated] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [selectedStatusID, setSelectedStatusID] = useState(null);
  const [searchParams] = useSearchParams();
  const [isVendorView, setIsVendorView] = useState(false);
  const [vendorToken, setVendorToken] = useState(null);
  const [isValidVendor, setIsValidVendor] = useState(true); // Default true until validation fails
  const [isAuthorized, setIsAuthorized] = useState(true);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [files, setFiles] = useState([]);
  const [fileNames, setFileNames] = useState([]);

  function handleFileChange(event) {
    if (event.target.files.length > 0) {
      setFiles((prev) => [...prev, ...Array.from(event.target.files)]);
    }
  }

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  // const editorRef = useRef(null);
  // const log = () => {
  //   if (editorRef.current) {
  //     console.log(editorRef.current.getContent());
  //     setDescription(editorRef.current.getContent());
  //   }
  // };

  const [toggleState, setToggleState] = React.useState(false);

  const handleToggleChange = () => {
    if (toggleState) {
      setVendorDescription("");
      setVendorAttachment("");
    }
    setToggleState(!toggleState);
  };

  const [ticketData, setTicketData] = useState([]);
  const [vendorName, setVendorName] = useState("");
  const [txtVendorDescription, setVendorDescription] = useState("");
  const [txtVendorAttachment, setVendorAttachment] = useState("");

  const [issueTypeList, setIssueTypeList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [ticketStatusList, setTicketStatusList] = useState([]);
  const [repetedTicketStatusList, setRepetedTicketStatusList] = useState([]);
  const [statusDataList, setStatusDataList] = useState([]);

  let updateRef = useRef(false);

  let assetsRef = useRef(false);
  useEffect(() => {
    if (assetsRef.current === false) {
      addContentTo("", "txtDescription");
      let data = JSON.stringify({
        intUserID: userData?.id || 0,
        intTicketID: parseInt(ticketID),
        intSPType: 3,
      });
      console.log(data);
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          // const da = response.data["data"].created_at;
          // console.log(moment(da).format("ddd, DD MMM Y, hh:mm A"));
          console.log(
            response.data["data"][0].ticket_attachment.replace(".", baseURL1),
            "130"
          );
          setTicketData(response.data["data"]);
          setVendorAttachment(
            response.data["data"][0].ticket_attachment.replace(".", baseURL1)
          );
          setVendorName(
            response.data["data"][0].vendor_name === null
              ? ""
              : response.data["data"][0].vendor_name
          );
        })
        .catch(function (error) {
          console.log(error);
        });

      data = JSON.stringify({
        intUserID: userData?.id || 0,
        intTicketID: parseInt(ticketID),
        intSPType: 5,
      });
      console.log(data);
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          // const da = response.data["data"].created_at;
          // console.log(moment(da).format("ddd, DD MMM Y, hh:mm A"));
          setContactDetails(response.data["data"][0]);
          // console.log(response.data["data"][0].email)
        })
        .catch(function (error) {
          console.log(error);
        });

      data = JSON.stringify({
        intUserID: userData?.id || 0,
        intTicketID: parseInt(ticketID),
        intSPType: 6,
      });
      console.log(data);
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          setTimelineList(response.data["data"]);
        })
        .catch(function (error) {
          console.log(error);
        });

      data = JSON.stringify({
        intTicketID: parseInt(ticketID),
        intSPType: 13,
      });
      console.log(data);
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          // const da = response.data["data"].created_at;
          // console.log(moment(da).format("ddd, DD MMM Y, hh:mm A"));
          setVendorList(response.data["data"]);
          // console.log(response.data["data"][0].email)
        })
        .catch(function (error) {
          console.log(error);
        });

      data = JSON.stringify({
        intTicketID: parseInt(ticketID),
        intUserID: userData?.id || 0,
        intSPType: 24,
      });

      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;

      axios(config)
        .then(function (response) {
          const result = response.data?.data;
          console.log("result:", result);
          if (result) {
            if (Array.isArray(result)) {
              setStatusDataList(result);
            }
            // setApprovalStatus(result.status); // "Approve" or "Decline"
            // setDeclineReason(result.decline_reason || ""); // Only for Decline
          }
        })
        .catch(function (error) {
          console.error(error);
        });

      data = JSON.stringify({
        intTicketID: parseInt(ticketID),
        intSPType: 16,
      });
      console.log(data);
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          // const da = response.data["data"].created_at;
          // console.log(moment(da).format("ddd, DD MMM Y, hh:mm A"));
          setAgentList(response.data["data"]);
          // console.log(response.data["data"][0].email)
        })
        .catch(function (error) {
          console.log(error);
        });

      data = JSON.stringify({
        parent_id: 43,
      });

      config.method = "patch";
      config.url = statusAPI;
      config.data = data;

      axios(config)
        .then(function (response) {
          setTicketStatusList(response.data["data"]);
        })
        .catch(function (error) {
          console.log(error);
        });

      data = JSON.stringify({
        parent_id: 176,
      });

      config.method = "patch";
      config.url = statusAPI;
      config.data = data;

      axios(config)
        .then(function (response) {
          setRepetedTicketStatusList(response.data["data"]);
        })
        .catch(function (error) {
          console.log(error);
        });

      return () => {
        assetsRef.current = true;
      };
    }
  }, []);

  useEffect(() => {
    const vToken = searchParams.get("vToken");
    const decrypted = vToken ? decryptVendorParams(vToken) : null;
    const vId = decrypted?.vId || searchParams.get("vId") || searchParams.get("vld") || searchParams.get("vid");
    const vEmail = decrypted?.vEmail || searchParams.get("vEmail") || searchParams.get("vemail");

    if (vId && vEmail) {
      setIsVendorView(true);
      setVendorID(parseInt(vId));
      // Validate vendor
      const data = JSON.stringify({
        intTicketID: parseInt(ticketID),
        intVendorID: parseInt(vId),
        txtField: vEmail,
        intSPType: 29, 
      });
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          // If the vendor assignment is invalid or already replied
          if (response.data.data.length === 0 || response.data.data[0].isAuthorized === 0) {
            setIsAuthorized(false);
          }
        })
        .catch(function (error) {
          console.error("Vendor validation error:", error);
          setIsAuthorized(false);
        });
    }
  }, [searchParams, ticketID]);

  const childRef = useRef();
  const handleAssignAgent = () => {
    setIsAssigningAgent(true);
    console.log(ticketID);
    console.log(intAgentID);
    const data = JSON.stringify({
      intAgentID: parseInt(intAgentID),
      intTicketID: parseInt(ticketID),
      intUserID: userData?.id || 0,
      intSPType: 17,
    });
    console.log(data);
    config.method = "POST";
    config.data = data;
    config.url = agentDashboardAPI;
    setIsLoadingSubmit(true);
    axios(config)
      .then(function (response) {
        setIsAssigningAgent(false);
        if (
          response.data.message ===
          "Please choose another IT admin, You are trying to assign an existing IT admin"
        ) {
          childRef.current.triggerAlert(
            JSON.stringify({
              message:
                "Please choose another IT admin, You are trying to assign an existing IT admin",
              messageType: "warning",
            })
          );
        } else {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: "IT admin assigned",
              messageType: "success",
            })
          );
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsAssigningAgent(false);
      })
      .finally(() => setIsLoadingSubmit(false));
  };

  const handleChangeCategory = () => {
    setIsChangingCategory(true);
    const data = JSON.stringify({
      intSubCategory: intSubCategory,
      intTicketID: parseInt(ticketID),
      intSPType: 11,
    });
    console.log(data);
    config.method = "POST";
    config.data = data;
    config.url = agentDashboardAPI;
    axios(config)
      .then(function (response) {
        setIsChangingCategory(false);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: "Category has been changed",
            messageType: "success",
          })
        );
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsChangingCategory(false);
      })
      .finally(() => setIsLoadingSubmit(false));
  };

  const handleAssignVendor = () => {
    setIsAssigningVendor(true);
    let description = "";
    let attachment = "";

    if (toggleState) {
      description = txtVendorDescription;
      attachment = txtVendorAttachment;
    }

    const data = JSON.stringify({
      intSubCategory: intVendorID,
      txtDescription: description,
      txtAttachment: attachment,
      intUserID: userData?.id || 0,
      intTicketID: parseInt(ticketID),
      intSPType: 12,
    });
    console.log(data);
    config.method = "POST";
    config.data = data;
    config.url = agentDashboardAPI;
    axios(config)
      .then(function (response) {
        setIsAssigningVendor(false);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: "Vendor assigned",
            messageType: "success",
          })
        );

        const found = vendorList.find((obj) => {
          return obj.id === intVendorID;
        });
        setVendorName(found.vendor_name);
        setVendorDescription(found.ticket_description);
        setVendorAttachment(found.ticket_attachment);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsAssigningVendor(false);
      })
      .finally(() => setIsLoadingSubmit(false));
  };

  const [ticketStatusID, setTicketStatusID] = useState(0);
  const [repeatedTicketID, setRepeatedTicketID] = useState(0);
  const handleTicketStatusChange = () => {
    const data = JSON.stringify({
      intStatusID: ticketStatusID,
      intTicketID: parseInt(ticketID),
      intUserID: userData?.id || 0,
      intSPType: 19,
    });
    console.log(data);
    config.method = "POST";
    config.data = data;
    config.url = agentDashboardAPI;
    setIsLoadingSubmit(true);
    axios(config)
      .then(function (response) {
        // setTimelineList(response.data["data"]);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: response.data.message,
            messageType: "success",
          })
        );

        const found = vendorList.find((obj) => {
          return obj.id === intVendorID;
        });
        setVendorName(found.vendor_name);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      })
      .finally(() => setIsLoadingSubmit(false));
  };

  const handleTicketRepeated = () => {
    setIsMarkingRepeated(true);
    const data = JSON.stringify({
      intStatusID: repeatedTicketID,
      intTicketID: parseInt(ticketID),
      intUserID: userData?.id || 0,
      intSPType: 20,
    });
    console.log(data);
    config.method = "POST";
    config.data = data;
    config.url = agentDashboardAPI;
    setIsLoadingSubmit(true);
    axios(config)
      .then(function (response) {
        // setTimelineList(response.data["data"]);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: response.data.message,
            messageType: "success",
          })
        );

        const found = vendorList.find((obj) => {
          return obj.id === intVendorID;
        });
        setVendorName(found.vendor_name);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      })
      .finally(() => setIsLoadingSubmit(false));
  };

  //

  useEffect(() => {
    if (updateRef.current === false) {
      // getInnerHtml("txtDescription") = "";
      let data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "1",
      });
      config.method = "PATCH";
      config.data = data;
      config.url = ticketAPI;
      axios(config)
        .then(function (response) {
          setIssueTypeList(response.data["data"]);
        })
        .catch(function (error) {
          console.log(error);
        });

      return () => {
        updateRef.current = true;
      };
    }
  }, []);

  const options = issueTypeList.map((option) => {
    const firstLetter = option.category;
    return {
      firstLetter: firstLetter,
      ...option,
    };
  });

  const optionsAgent = agentList.map((option) => {
    if (option.name !== null) {
      const firstLetter = option.name[0].toUpperCase();
      return {
        firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
        ...option,
      };
    }
  });

  const vendorOptions = vendorList.map((option) => {
    // const firstLetter = option.vendor_name;
    // return {
    //   firstLetter: firstLetter,
    //   ...option,
    // };
    const firstLetter = (option.vendor_name[0] || "").toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });

  //

  //   FETCH ASSETS DATA START
  const [assetsList, setAssetsList] = useState([]);
  const fetchAssets = () => {
    const data = JSON.stringify({
      intTicketID: parseInt(ticketID),
      txtAssets: "",
      intIssueSubType: intIssueSubType,
      intSPType: 3,
    });

    config.method = "PATCH";
    config.data = data;
    config.url = assetsAPI;
    // setIsDataLoading(true);
    axios(config)
      .then(function (response) {
        setAssetsList([]);
        if (response.data.data.length > 0) {
          setAssetsList(JSON.parse(response.data.data[0].assets));
        }
        // childRef.current.setData(assets1);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        // setIsDataLoading(false);
      });
  };

  // FETCH ASSETS DATA END

  // REPLAY START
  const handleReplyButtonClick = () => {
    if (isVendorView) {
      handleReply(49);
    } else {
      setOpenStatusDialog(true);
    }
  };

  const handleStatusSelect = (statusID) => {
    handleReply(statusID);
  };

  const handleReply = (statusID) => {
    const description = getInnerHtml("txtDescription");
    if (!cleanText(description) && files.length === 0) {
      childRef.current.triggerAlert(
        JSON.stringify({
          message: "Please enter a message or attach a file.",
          messageType: "warning",
        })
      );
      setIsReplying(false);
      return;
    }
    setIsReplying(true);
    // console.log(txtDescription);
    // setDescription(editorRef.current.getContent());
    // const data = JSON.stringify({
    //   intUserID: userData.id,
    //   intTicketID: parseInt(ticketID),
    //   txtDescription: getInnerHtml("txtDescription"), //editorRef.current.getContent(),
    //   intSPType: 7,
    // });

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file[]", file);
    });
    formData.append("intUserID", isVendorView ? 0 : (userData?.id || 0));
    if (isVendorView) {
      formData.append("intVendorID", parseInt(searchParams.get("vId") || searchParams.get("vld") || searchParams.get("vid") || intVendorID));
    }
    formData.append("intTicketID", parseInt(ticketID));
    formData.append("txtDescription", getInnerHtml("txtDescription"));
    formData.append("intStatusID", isVendorView ? 49 : statusID); // Passing the selected status ID
    formData.append("intSPType", 7);

    var config1 = {
      method: "PATCH",
      url: agentDashboardAPI,
      mode: "cors",
      headers: {
        "Content-Type": "multipart/form-data",
        // Only include Authorization if not in vendor view (authorized via link)
        ...(isVendorView ? {} : { Authorization: "Bearer " + userData?.token }),
      },
      data: formData,
      onUploadProgress: (event) => {
        console.log(
          `Current progress:`,
          Math.round((event.loaded * 100) / event.total)
        );
      },
    };

    setIsLoadingSubmit(true);

    axios(config1)
      .then(function (response) {
        console.log(response);

        if (statusID === 187) {
          // Trigger the email notification via SPType 30
          // Passing txtDescription so it can be included in the email
          const data30 = JSON.stringify({
            intTicketID: parseInt(ticketID),
            intSPType: 30,
            txtDescription: getInnerHtml("txtDescription")
          });

          const config30 = {
            method: "POST",
            url: agentDashboardAPI,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userData?.token
            },
            data: data30
          };

          axios(config30)
            .then(() => console.log(`[Update] Successfully triggered SPType 30 notification.`))
            .catch(err => console.error("[Update] Error triggering vendor email notification:", err));
        }

        setIsReplying(false);
        // reset();
        // setOpen(true);
        // setMessageType("success");
        // setMessage(response.data.message);
        setTimeout(function () {
          window.location.reload();
        }, 2000);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsReplying(false);
        // setMessageType("warning");
        // setMessage(error.response.data.message);
      })
      .finally(() => {
        setIsLoadingSubmit(false);
        setOpenStatusDialog(false);
      });

    // console.log(data);
    // config.method = "PATCH";
    // config.data = data;
    // config.url = agentDashboardAPI;
    // axios(config)
    //   .then(function (response) {
    //     // const da = response.data["data"].created_at;
    //     // console.log(moment(da).format("ddd, DD MMM Y, hh:mm A"));
    //     setDescription("");
    //     // setTicketData(response.data["data"]);
    //     let data = JSON.stringify({
    //       intUserID: userData.id,
    //       intTicketID: parseInt(ticketID),
    //       intSPType: 3,
    //     });
    //     console.log(data);
    //     config.method = "PATCH";
    //     config.data = data;
    //     config.url = agentDashboardAPI;
    //     axios(config)
    //       .then(function (response) {
    //         // const da = response.data["data"].created_at;
    //         // console.log(moment(da).format("ddd, DD MMM Y, hh:mm A"));
    //         setTicketData(response.data["data"]);
    //       })
    //       .catch(function (error) {
    //         if (error.message === "Network Error") {
    //           localStorage.removeItem("user");
    //           window.location.href = window.location.origin + "/";
    //         }
    //         console.log(error);
    //       });
    //   })
    //   .catch(function (error) {
    //     if (error.message === "Network Error") {
    //       localStorage.removeItem("user");
    //       window.location.href = window.location.origin + "/";
    //     }
    //     console.log(error);
    //   });
  };

  // REPLAY END

  const cleanText = (text) =>
    text
      ?.replace(/<[^>]+>/g, "") // Remove HTML tags
      .replace(/&nbsp;/g, " ") // Replace &nbsp; with space
      .replace(/\s+/g, " ") // Collapse multiple spaces
      .trim();

  return (
    <Layout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isLoadingSubmit}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Please wait...
        </Typography>
      </Backdrop>

      <AlertMessage ref={childRef} />
      <Grid container sx={isVendorView ? { marginTop: 0 } : { marginTop: "30px" }}>
        <Grid item xs={12} lg={isVendorView ? 12 : 9} md={12} className="content-details">
          {/* <Container> */}
          {ticketData.length > 0 ? (
            <>
              {ticketData.map((row, index) => {
                const cleanRowDesc = cleanText(row.ticket_description);
                const isMatched = statusDataList.find(
                  (item) => item.ticket_description?.trim() === cleanRowDesc
                );
                // if (index === 0) {
                // let createdAt = ``;
                // if (row.year !== "0") {
                //   createdAt += row.year + ` Years`;
                // } else if (row.month !== "0") {
                //   createdAt += row.month + ` Months`;
                // } else if (row.day !== "0") {
                //   createdAt += row.day + ` days`;
                // } else if (row.hour !== "0") {
                //   createdAt += row.hour + ` hours`;
                // } else if (row.minute !== "0") {
                //   createdAt += row.minute + ` minutes`;
                // } else if (row.second !== "0") {
                //   createdAt += row.second + ` seconds`;
                // }
                // debugger
                // createdAt += ` ago`;
                return (
                  <div key={index}>
                    <div>
                        <Typography variant="h4" fontWeight="600">
                          {row.ticketSubject}
                        </Typography>
                      {index === 0 ? (
                        <Grid
                          marginTop={`20px`}
                          display={`flex`}
                          gap={`10px`}
                          alignItems={`center`}
                        >
                          <Typography fontWeight={`600`} fontSize={`16px`}>
                            Ticket ID:
                          </Typography>
                          <Typography fontWeight={`500`} fontSize={`16px`}>
                            {row.ticketID}
                          </Typography>
                          <FiberManualRecordIcon sx={{ fontSize: 7 }} />

                          <Typography fontWeight={`600`} fontSize={`16px`}>
                            Category:
                          </Typography>
                          <Typography fontWeight={`500`} fontSize={`16px`}>
                            {row.ticketCategory}
                          </Typography>
                          <FiberManualRecordIcon sx={{ fontSize: 7 }} />

                          <Typography fontWeight={`600`} fontSize={`16px`}>
                            Sub Category:
                          </Typography>
                          <Typography fontWeight={`500`} fontSize={`16px`}>
                            {row.sub_category}
                          </Typography>
                          <FiberManualRecordIcon sx={{ fontSize: 7 }} />

                          <Typography fontWeight={`600`} fontSize={`16px`}>
                            Prioritization:
                          </Typography>
                          <Typography fontWeight={`500`} fontSize={`16px`}>
                            {row.ticketType}
                          </Typography>
                          {/* <FiberManualRecordIcon sx={{ fontSize: 10 }} /> */}
                        </Grid>
                      ) : (
                        <></>
                      )}
                      {index === 0 && (() => {
                        const agentFlow = ticketData
                          .filter(r => r.role === "1" || r.role === "2")
                          .map(r => r.name)
                          .reverse()
                          .filter((name, i, arr) => i === 0 || arr[i - 1] !== name);

                        return agentFlow.length > 0 ? (
                          <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", mt: 1, mb: 1 }}>
                            {agentFlow.map((agentName, i) => (
                              <React.Fragment key={i}>
                                <Typography sx={{ color: "#7b1fa2", fontWeight: 600, fontSize: "14px" }}>
                                  {agentName}
                                </Typography>
                                {i < agentFlow.length - 1 && (
                                  <Box component="span" sx={{ color: "#7b1fa2", fontWeight: 700, fontSize: "14px", verticalAlign: "middle", position: "relative", top: "-1px" }}>→</Box>
                                )}
                              </React.Fragment>
                            ))}
                          </Box>
                        ) : null;
                      })()}
                      <Typography variant="span" fontSize="16px" color={`red`}>
                        {row.new_sub_category_name !== "" &&
                          row.new_sub_category_name !== null ? (
                          `(This ticket category has been changed ${row.sub_category} to ${row.new_sub_category_name})`
                        ) : (
                          <></>
                        )}
                      </Typography>
                      <div className="empty-space-20"></div>
                      <Grid
                        display="flex"
                        gap="10px"
                        alignItems={`center`}
                        justifyContent={`space-between`}
                        sx={{
                          flexDirection: { xs: "column", md: "row" },
                          mr: 1,
                        }}
                      >
                        <Grid display="flex" gap="10px" alignItems={`center`}>
                          <UserAvatar name={row.reply_type === "Vendor" ? row.vendor_name : row.ticketCreatedUserName} />
                          <Grid>
                            <Typography>
                              {index === 0 ? (
                                <>Created by</>
                              ) : (
                                <>Replied by</>
                              )}{" "}
                              <strong>
                                {row.reply_type === "Vendor"
                                  ? `${row.vendor_name} (Vendor)`
                                  : row.ticketCreatedUserName}
                              </strong>
                            </Typography>
                            <Typography>
                              {/* <i>{row.created_at}</i> */}
                              {moment
                                .utc(row.created_at)
                                .utcOffset("+05:30")
                                .format("MMM DD, YYYY, hh:mm A")}
                            </Typography>
                          </Grid>
                        </Grid>
                        {index !== 0 && (row.assigned_by_name || row.agent_name) && (
                          <Grid item>
                            {row.assigned_by_name && (
                              <Typography sx={{ textAlign: { xs: "left", md: "right" }, color: '#000', fontWeight: '600' }}>
                                Assigned By: <span style={{ color: '#7b1fa2' }}>{row.assigned_by_name}</span>
                              </Typography>
                            )}
                            {row.agent_name && (
                              <Typography sx={{ textAlign: { xs: "left", md: "right" }, color: '#000', fontWeight: '600' }}>
                                Assigned To: <span style={{ color: '#7b1fa2' }}>{row.agent_name}</span>
                              </Typography>
                            )}
                          </Grid>
                        )}
                      </Grid>
                      {row.ticket_attachment && row.ticket_attachment !== "" ? (
                        <Box display="flex" flexWrap="wrap" gap="10px" sx={{ mt: 2, mb: 1, px: 1 }}>
                          {row.ticket_attachment.split(",").map((url, i) => {
                            const fileName = url.substring(url.lastIndexOf("/") + 1);
                            const displayName = fileName.includes("_") ? fileName.substring(fileName.indexOf("_") + 1) : fileName;
                            return (
                              <a
                                key={i}
                                href={url}
                                target={"_blank"}
                                className={`btn-download`}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  minWidth: '220px',
                                  maxWidth: '280px',
                                  height: '42px',
                                  justifyContent: 'center',
                                  padding: '0 15px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}
                                title={decodeURIComponent(displayName)}
                              >
                                <DownloadIcon sx={{ fontSize: 18 }} />
                                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                  {decodeURIComponent(displayName)}
                                </span>
                              </a>
                            );
                          })}
                        </Box>
                      ) : (
                        <></>
                      )}

                      {/* <div className="empty-space-20"></div> */}

                      <div className="empty-space-20"></div>
                      <Grid>
                        {/* <Typography>{row.ticket_description}</Typography> */}
                        <Typography
                          dangerouslySetInnerHTML={{
                            __html: row.ticket_description,
                          }}
                        ></Typography>
                      </Grid>
                    </div>
                    <div className="empty-space-20"></div>
                    {userData?.role === "Admin" &&
                      (isMatched && isMatched.status ? (
                        // ✅ Show read-only status accordion if match found
                        <Accordion
                          className="accordion-box-shadow reply-section"
                          expanded={expanded === `panel${index}`}
                          onChange={handleChange(`panel${index}`)}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${index}a-content`}
                            id={`panel${index}-header`}
                          >
                            <Typography color={isMatched.status === "Decline" ? "error.main" : "success.main"}>
                              {isMatched.status === "Decline"
                                ? "Declined by Department Head"
                                : "Approved by Department Head"}
                            </Typography>
                          </AccordionSummary>

                          {isMatched.status === "Decline" && (
                            <AccordionDetails>
                              <Box
                                sx={{
                                  backgroundColor: "#f9eaea",
                                  border: "1px solid #e0b4b4",
                                  borderRadius: "8px",
                                  padding: "12px",
                                  marginBottom: "16px",
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  color="error"
                                  fontWeight="bold"
                                >
                                  Decline Reason:
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {isMatched.decline_reason}
                                </Typography>
                              </Box>
                            </AccordionDetails>
                          )}
                          {isMatched.status === "Approve" && (
                            <AccordionDetails>
                              <Box
                                sx={{
                                  backgroundColor: "#e6f4ea",
                                  border: "1px solid #a5d6a7",
                                  borderRadius: "8px",
                                  padding: "12px",
                                  marginBottom: "16px",
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  color="success.main"
                                  fontWeight="bold"
                                >
                                  Approved
                                </Typography>
                              </Box>
                            </AccordionDetails>
                          )}
                        </Accordion>
                      ) : null)}
                    <div className="empty-space-20"></div>
                    <hr className="hrLine" />
                  </div>
                );
                // }
              })}
            </>
          ) : (
            <></>
          )}

          <div className="empty-space-20"></div>

          {!isAuthorized && isVendorView && (
            <Alert sx={{ marginBottom: '20px' }} severity="error">
              Unauthorized: This link is invalid or has already been used.
            </Alert>
          )}

          {(ticketData[0]?.review === null ||
            ticketData[0]?.review === undefined ||
            ticketData[0]?.review === "" ||
            Number(ticketData[0]?.review) === 0) && isAuthorized && (
              <div className="reply-section">
                <Grid>
                  <TextEditor
                    id="txtDescription"
                    fullWidth
                    showHeadings={false}
                    showUndoRedo={false}
                    showJustify={false}
                  />
                </Grid>

                <Grid marginTop={`10px`}>
                  <input
                    type="file"
                    multiple
                    onChange={handleFileChange}
                    style={{ marginBottom: "10px" }}
                  />
                  {files.length > 0 && (
                    <div style={{ marginTop: "10px" }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Selected Files:
                      </Typography>
                      <ul style={{ listStyle: "none", padding: 0 }}>
                        {files.map((f, index) => (
                          <li
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginBottom: "5px",
                              padding: "5px 10px",
                              backgroundColor: "#f5f5f5",
                              borderRadius: "4px",
                            }}
                          >
                            <Typography variant="caption">{f.name}</Typography>
                            <Button
                              size="small"
                              color="error"
                              onClick={() => handleRemoveFile(index)}
                              style={{ minWidth: "auto", padding: "2px 5px" }}
                            >
                              Remove
                            </Button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </Grid>

                <div className="empty-space-20"></div>
                <Grid display="flex" gap="20px" justifyContent={`flex-end`}>
                  <Button
                    className="btn-primary"
                    onClick={handleReplyButtonClick}
                    startIcon={<SendIcon />}
                    disabled={isLoadingSubmit}
                  >
                    Reply
                  </Button>
                </Grid>
              </div>
            )}

          <Dialog open={openStatusDialog} onClose={() => setOpenStatusDialog(false)}>
            <DialogTitle>Select Status for Reply</DialogTitle>
            <DialogContent>
              <List>
                {[
                  { id: 49, name: "Pending by IT Admin" },
                  { id: 47, name: "Pending by User" },
                  { id: 46, name: "On hold" },
                  ...(ticketData[0]?.vendor_name ? [{ id: 187, name: "Pending by Vendor" }] : [])
                ].map((status) => (
                  <ListItem disablePadding key={status.id}>
                    <ListItemButton onClick={() => handleStatusSelect(status.id)}>
                      <ListItemText primary={status.name} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenStatusDialog(false)}>Cancel</Button>
            </DialogActions>
          </Dialog>
          {/* </Container> */}
        </Grid>

        {!isVendorView && (
          <Grid item xs={12} lg={3} md={12} marginTop={`30px`}>
            <Container>
              <Accordion
                className="accordion-box-shadow"
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Contact Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>Email</Typography>
                  <Typography>
                    <strong>{contactDetails["email"]}</strong>
                  </Typography>
                  <div className="empty-space-30"></div>

                  <Typography>Mobile</Typography>
                  <Typography>
                    <strong>
                      {contactDetails["phone"] === `undefined`
                        ? "-"
                        : contactDetails["phone"]}
                    </strong>
                  </Typography>
                  <div className="empty-space-30"></div>

                  <Typography>No of Ticket</Typography>
                  <Typography>
                    <strong>{contactDetails["no_of_ticket"]}</strong>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                className="accordion-box-shadow"
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Timeline</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Timeline
                    sx={{
                      [`& .${timelineOppositeContentClasses.root}`]: {
                        flex: 0.2,
                      },
                    }}
                  >
                    <TimelineItem className="timeline">
                      <TimelineOppositeContent color="textSecondary">
                        {ticketData.map((row, index) => (
                          <div key={index}>
                            {index === 0 ? (
                              <>
                                {moment
                                  .utc(row.created_at)
                                  .utcOffset("+05:30")
                                  .format("DD MMM Y")}
                                <br />
                                {moment
                                  .utc(row.created_at)
                                  .utcOffset("+05:30")
                                  .format("hh:mm A")}
                              </>
                            ) : null}
                          </div>
                        ))}
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot className="open-ticket" />
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent>Open</TimelineContent>
                    </TimelineItem>

                    {timelineList.map((row, index) => (
                      <TimelineItem className="timeline" key={index}>
                        <TimelineOppositeContent color="textSecondary">
                          {moment
                            .utc(row.created_at)
                            .utcOffset("+05:30")
                            .format("DD MMM Y")}
                          <br />
                          {moment
                            .utc(row.created_at)
                            .utcOffset("+05:30")
                            .format("hh:mm A")}
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineDot className="open-ticket" />
                          {timelineList.length - 1 !== index ? (
                            <TimelineConnector />
                          ) : null}
                        </TimelineSeparator>
                        <TimelineContent>{row.name}</TimelineContent>
                      </TimelineItem>
                    ))}
                  </Timeline>
                </AccordionDetails>
              </Accordion>

              {ticketData[0]?.ticket_status !== 48 && (
                <Accordion
                  className={`accordion-box-shadow reply-section`}
                  expanded={expanded === "panel3"}
                  onChange={handleChange("panel3")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography>Change Category</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <FormControl className={`form-control`} fullWidth>
                      <Autocomplete
                        id="grouped-demo"
                        options={options}
                        groupBy={(option) => option.firstLetter}
                        getOptionLabel={(option) => option.name}
                        fullWidth
                        renderInput={(params) => (
                          <TextField {...params} label="Category" />
                        )}
                        onChange={(event, newValue) => {
                          if (newValue !== null) {
                            setSubCategory(newValue.id);
                          }
                        }}
                      />
                    </FormControl>
                    <Grid display="flex" gap="20px" justifyContent={`flex-end`}>
                      <Button
                        className="btn-primary"
                        onClick={handleChangeCategory}
                        disabled={isLoadingSubmit}
                      >
                        Change Category
                      </Button>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              )}

              {ticketData[0]?.ticket_status !== 48 && (
                <Accordion
                  className={`accordion-box-shadow reply-section`}
                  expanded={expanded === "panel4"}
                  onChange={handleChange("panel4")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4a-content"
                    id="panel4a-header"
                  >
                    <Typography>Assign Vendor</Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    {vendorName === "" ? (
                      <>
                        <FormControl className={`form-control`} fullWidth>
                          <Autocomplete
                            id="grouped-demo"
                            options={vendorOptions}
                            groupBy={(option) => option.firstLetter}
                            getOptionLabel={(option) => option.vendor_name}
                            fullWidth
                            renderInput={(params) => (
                              <TextField {...params} label="Vendor" />
                            )}
                            onChange={(event, newValue) => {
                              if (newValue !== null) {
                                setVendorID(newValue.id);
                              }
                            }}
                          />
                          <Typography className="invalid-feedback">
                            {vendorNameError}
                          </Typography>
                        </FormControl>

                        <FormControl
                          className={`form-control`}
                          fullWidth
                          style={{ backgroundColor: "lightpurple" }}
                        >
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={toggleState}
                                  onChange={handleToggleChange}
                                />
                              }
                            />
                          </FormGroup>
                        </FormControl>

                        <FormControl className={`form-control`} fullWidth>
                          <TextField
                            id="outlined-multiline-static"
                            label="Vendor Message"
                            multiline
                            rows={4}
                            fullWidth
                            value={txtVendorDescription}
                            onChange={(e) => setVendorDescription(e.target.value)}
                          />
                        </FormControl>
                        <Grid display="flex" gap="20px" justifyContent={`flex-end`}>
                          <Button
                            className="btn-primary"
                            onClick={handleAssignVendor}
                            disabled={isLoadingSubmit}
                          >
                            Update
                          </Button>
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Typography fontWeight={`600`} fontSize={`18px`}>
                          Assigned Vendor Name{" "}
                        </Typography>
                        <Typography
                          variants="h4"
                          marginTop={2}
                          fontSize={`17px`}
                          fontWeight={`500`}
                        >
                          {vendorName}
                        </Typography>
                      </>
                    )}
                  </AccordionDetails>
                </Accordion>
              )}

              {ticketData[0]?.ticket_status !== 48 && (
                <Accordion
                  className={`accordion-box-shadow reply-section`}
                  expanded={expanded === "panel5"}
                  onChange={handleChange("panel5")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography>Assign IT admin</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <FormControl className={`form-control`} fullWidth>
                      <Autocomplete
                        id="grouped-demo"
                        options={optionsAgent}
                        groupBy={(option) => option.firstLetter}
                        getOptionLabel={(option) => option.name}
                        fullWidth
                        renderInput={(params) => (
                          <TextField {...params} label="IT Admin" />
                        )}
                        onChange={(event, newValue) => {
                          if (newValue !== null) {
                            setAgentID(newValue.id);
                          }
                        }}
                      />
                    </FormControl>

                    <Grid display="flex" gap="20px" justifyContent={`flex-end`}>
                      <Button
                        className="btn-primary"
                        onClick={handleAssignAgent}
                        disabled={isLoadingSubmit}
                      >
                        Assign
                      </Button>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              )}

              {userData?.role === "role" &&
                ticketData[0]?.ticket_status !== 48 && (
                  <Accordion
                    className={`accordion-box-shadow reply-section`}
                    expanded={expanded === "panel6"}
                    onChange={handleChange("panel6")}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography>Change Status</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <FormControl className={`form-control`} fullWidth>
                        <InputLabel>Ticket Status</InputLabel>
                        <Select
                          labelId="Ticket Status"
                          id="demo-simple-select-helper"
                          value={ticketStatusID}
                          label="Ticket Status"
                          onChange={(e) => setTicketStatusID(e.target.value)}
                          name="ddlType"
                        >
                          {ticketStatusList.map((row, index) => (
                            <MenuItem value={row.id} key={index}>
                              {row.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <Grid display="flex" gap="20px" justifyContent={`flex-end`}>
                        <Button
                          className="btn-primary"
                          onClick={handleTicketStatusChange}
                          disabled={isLoadingSubmit}
                        >
                          Assign
                        </Button>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}

              {ticketData[0]?.ticket_status !== 48 && (
                <Accordion
                  className={`accordion-box-shadow reply-section`}
                  expanded={expanded === "panel7"}
                  onChange={handleChange("panel7")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography>Mark as repeated</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <FormControl className={`form-control`} fullWidth>
                      <Autocomplete
                        id="repeated-ticket-autocomplete"
                        options={repetedTicketStatusList}
                        getOptionLabel={(option) => option.name || ""}
                        value={repetedTicketStatusList.find(r => r.id === repeatedTicketID) || null}
                        onChange={(event, newValue) => setRepeatedTicketID(newValue ? newValue.id : 0)}
                        renderInput={(params) => <TextField {...params} label="Repeated Ticket" />}
                        fullWidth
                      />
                    </FormControl>

                    <Grid display="flex" gap="20px" justifyContent={`flex-end`}>
                      <Button
                        className="btn-primary"
                        onClick={handleTicketRepeated}
                        disabled={isLoadingSubmit}
                      >
                        Assign
                      </Button>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              )}
              {isAuthorized && (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                  <Typography variant="body2" color="textSecondary">
                    Authorized Vendor Access
                  </Typography>
                </div>
              )}
            </Container>
          </Grid>
        )}
      </Grid>
    </Layout>
  );
}